import { autoinject, bindable, bindingMode, transient } from 'aurelia-framework';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { Toastr } from 'Code/Extension/Toastr';
import { ObjectCompareResult, ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { ValidationHelper } from 'Code/Helpers/ValidationHelper';
import { PromptController } from 'Code/Prompts/PromptController';
import { BaseView } from 'Common/BaseView';
import { DiscussionMessageModel } from 'Common/Code/DiscussionMessage/DiscussionMessageModel';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { DataService } from 'DataAccessLayer/Services/DataService';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { ValidateResult } from 'aurelia-validation';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { ResultInfo, ResultInfoStatus } from 'Common/Code/Model/ResultInfo';

@autoinject
export class OpportunityFormBaseCustomElement extends BaseCustomElement {

    @bindable({ defaultBindingMode: bindingMode.toView }) entityId: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = null;

    private portalPhase: number = 3;

    private created: string = null;
    private modified: string = null;
    private dataService: DataService = null;
    private _authService: AuthService = null;
    private promptController: PromptController = null;
    private i18n: I18N = null;
    private router: Router = null;
    private schema: any = null;
    private globalSchema: Object = null;
    private accessRight: Object = null;
    private element: any = null;
    private validationHelper: ValidationHelper = null;
    private validationRules: Array<any> = [];
    private validationRulesItemGrids: any = {};
    private routeConfig: any = null;

    private originData: any = null;
    private originDataIgnore: Array<string> = null;
    private entityData: any = null;

    constructor(dataService: DataService, router: Router, validationHelper: ValidationHelper, promptController: PromptController, i18n: I18N, authService: AuthService) {
        super();
        this.dataService = dataService;
        this.router = router;
        this.validationHelper = validationHelper;
        this.promptController = promptController;
        this.i18n = i18n;
        this._authService = authService;

        this.testBeforeUnload = e => {
            if (!ObjectHelper.IsNullOrUndefined(this.entityData) && !ObjectHelper.IsNullOrUndefined(this.originData)) {
                let compareResult: ObjectCompareResult = ObjectHelper.Compare(this.entityData, this.originData, this.originDataIgnore, true)
                console.log('testBeforeUnload', compareResult);
                if (!compareResult.Same) {
                    e.preventDefault(); // Cancel the event
                    e.returnValue = '';// Chrome requires returnValue to be set
                }
            }
        };
    }

    protected testBeforeUnload(e) {
    }

    attached() {
        window.addEventListener('beforeunload', this.testBeforeUnload);
    }
    detached() {
        window.removeEventListener('beforeunload', this.testBeforeUnload);
    }

    async loadData() {
        let response = await this.dataService.GetById(this.entityName, this.entityId);
        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data') && response['data'] != null && response['data'] != ObjectHelper.Empty()) {
            this.entityData = response['data'];
            if (ObjectHelper.ObjectIs(this.entityData.PortalPhase_FK)) {
                switch (this.entityData.PortalPhase_FK) {
                    case 15495:
                        this.portalPhase = 1;
                        break;
                    case 15496:
                        this.portalPhase = 2;
                        break;
                    case 15497:
                        this.portalPhase = 3;
                        break;
                    case 15498:
                        this.portalPhase = 4;
                        break;
                    case 15499:
                        this.portalPhase = 5;
                        break;
                    case 15500:
                        this.portalPhase = 6;
                        break;
                    case 15501:
                        this.portalPhase = 7;
                        break;
                }

            }
            this.originData = JSON.parse(JSON.stringify(this.entityData));

            console.log(5552, 'GetById', this.entityData);
        }
    }

    async bind() {
        await this.loadData();

        this.schema = await SystemService.Instance.GetSchemaByEntity(this.entityName);
        this.globalSchema = await SystemService.Instance.GetSchema();
        this.originDataIgnore = await SystemService.Instance.GetColumnListToIgnore(this.entityName);

        this.accessRight = await SystemService.Instance.GetAccessRightByEntity(this.entityName);
        this.validationRules = await this.validationHelper.createRules(this.entityName, this.schema, null, false);

        this.validationRulesItemGrids = {};
        if (ObjectHelper.ArrayIs(this.schema.ItemGrid)) {

            for (let i1 = 0; i1 < this.schema.ItemGrid.length; i1++) {
                const entityName1: string = this.schema.ItemGrid[i1].EntityName;
                let schema1 = await SystemService.Instance.GetSchemaByEntity(entityName1);
                this.validationRulesItemGrids[entityName1] = await this.validationHelper.createRules(entityName1, schema1, null, true, true);
            }
        }
    }

    public GoBack() {
        window.history.back();
    }

    public async SaveAndStay() {
        let r1 = await this.Save();
        console.log(5555555, r1);
        if (r1) {
            await this.loadData();
        }
    }

    public async Save(): Promise<boolean> {
        const validateResult: Array<ValidateResult> = await this.validationHelper.Validate(this.entityName, this.entityData, this.validationRules, this.validationRulesItemGrids);

        if (ObjectHelper.ArrayIs(validateResult)) {
            Toastr.ValidateError(validateResult);
            return false;
        }
        else {
            console.log(11111);
            //SaveProgress.Show();

            let responseSave: any = await this.dataService.Save(this.entityName, this.entityId, this.entityData);
            //console.log(11112, responseSave['status']);
            switch (responseSave['status']) {
                case 'OK': {
                    let mess = await SystemService.Instance.GetStringFromErrorList(responseSave.validationErrList, this.schema);
                    if (StringHelper.StringIs(mess)) {
                        Toastr.Warning('Toastr.Oooops', mess, false);
                    }

                    // set data and origin data as null 'cause those have to be same after save
                    this.originData = null;
                    this.entityData = null;
                    Toastr.Success('Toastr.Done', 'Toastr.SavingFormWasSuccessful');
                    //SaveProgress.Hide();
                    return true;
                }
                case 'InvalidJson': {
                    let messValidator = '';
                    let messWarning = '';
                    let messRequired = '';
                    if (ObjectHelper.ArrayIs(responseSave.data)) {
                        for (let i1 = 0; i1 < responseSave.data.length; i1++) {
                            const item1: any = responseSave.data[i1];
                            if (item1.ErrorType.toLowerCase() == 'validator') {
                                messValidator = messValidator + await SystemService.Instance.GetPathLocalizationString(item1, this.schema) + " - " + item1.Message + '<br>';
                            }
                            if (item1.ErrorType.toLowerCase() == 'warning') {
                                messWarning = messWarning + await SystemService.Instance.GetPathLocalizationString(item1, this.schema) + " - " + item1.Message + '<br>';
                            }
                            if (item1.ErrorType.toLowerCase() == 'required') {
                                messRequired = messRequired + item1.Message + '<br>';
                            }
                        }
                    }
                    if (StringHelper.StringIs(messValidator)) {
                        Toastr.Error('Toastr.ThisFormIsNotValid', messValidator, false);
                    }
                    if (StringHelper.StringIs(messWarning)) {
                        Toastr.Warning('Toastr.Oooops', messWarning, false);
                    }
                    if (StringHelper.StringIs(messRequired)) {
                        Toastr.Error('Toastr.ThisFormIsNotValid', messRequired, false);
                    }
                    break;
                }
            }
            //SaveProgress.Hide();
            return false;
        }
    }

    private stornoModal: any = null;

    private ShowStornoModal() {
        this.stornoModal = new bootstrap.Modal(document.getElementById(this.guid + "StornoModal"), {});
        console.log(555555, this.stornoModal);
        this.stornoModal.show();
    }

    private CloseStornoModal() {
        this.stornoModal.hide();
        this.stornoModal = null;
    }

    private async DoStorno() {
        let newMessage: DiscussionMessageModel = new DiscussionMessageModel(true);
        newMessage.Priority_FK = 1;
        newMessage.Type_FK = 1;
        newMessage.Status_FK = false;
        newMessage.Responsible_FK = null;
        newMessage.Text = "Storno";

        let result: ResultInfo = await this.dataService.SaveDiscussionMessage(this.entityId, this.entityName, null, newMessage, "/", false, false, false);
        //console.log(55, result);
        if (result.Status == ResultInfoStatus.OK) {
            Toastr.Success('Toastr.Done', 'Toastr.SavingFormWasSuccessful');
        } else {
            Toastr.Error('Toastr.Oooops', result.Message);
        }

        this.CloseStornoModal();
    }


}